<!-- modal aprob -->
<template>
  <div class="text-center">
    <v-dialog v-model="dialog"  persistent scrollable>
      <v-card class="va-card">
        <v-card-title class="va-hero py-3">
          <div class="d-flex align-center justify-space-between" style="width: 100%;">
            <div class="d-flex align-center" style="gap: 12px;">
              <v-avatar color="white" size="40" class="elevation-1">
                <v-icon color="teal darken-3">mdi-school</v-icon>
              </v-avatar>
              <div>
                <div class="text-h6 white--text">Programas Universidad aprobados · {{ $store.state.CARGO.sede.nombre }}</div>
                <div class="text-body-2 white--text" @click="$router.push('/programa_reg_from_oferta?edit=8155')">
                  Revisa el periodo y crea programas a partir de la oferta aprobada
                </div>
              </div>
            </div>
            <v-chip color="teal lighten-5" class="teal--text text--darken-3" small>
              Aprobados: {{ filteredEscogidos?filteredEscogidos[0]?filteredEscogidos[0].aprobados.length : 0 :0  }}
            </v-chip>
          </div>
        </v-card-title>

        <v-card-text class="pt-2">
          <v-divider class="mb-4" />
          <v-row dense class="mb-2">
            <v-col cols="12" sm="6" md="4">
              <v-select
                :items="xmeses"
                v-model="input.mes"
                label="Mes de oferta"
                item-value="id"
                item-text="text"
                dense
                outlined
                prepend-icon="mdi-calendar"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                label="Año de oferta"
                v-model.number="input.anio"
                dense
                outlined
                prepend-icon="mdi-calendar"
                type="number"
              />
            </v-col>
          </v-row>

          <v-row v-if="filteredEscogidos.length === 0">
            <v-col cols="12" class="text--secondary">
              <v-alert type="info" border="left" colored-border>
                No hay aprobados para el periodo seleccionado.
              </v-alert>
            </v-col>
          </v-row>

          <v-progress-linear indeterminate v-if="loading"></v-progress-linear>

          <v-row v-for="(e,ind) in filteredEscogidos" :key="ind" dense>
            <v-col cols="12">
              <v-card outlined class="pa-3">
                <div class="text-subtitle-2">Oferta: {{ e.nombre_oferta }}</div>
                <div class="text-body-2 text--secondary">
                  Periodo: {{ mesTexto(e.mes) }} · {{ e.anio }}
                </div>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-data-table
                :headers="xheaders_punis"
                :items="e.aprobados"
                :loading="loading"
                disable-pagination
                hide-default-footer 
                class="elevation-1"
                no-data-text="No hay aprobados en esta oferta"
              >
                <template v-slot:item.programaNombre="{ item }">
                  <div>
                    <div>{{ item.programaNombre }}</div>
                    <div class="caption grey--text">{{ item.areaUniversidad ? item.areaUniversidad.nombre : '' }}</div>
                  </div>
                </template>
                <template v-slot:item.ceubArchivoId="{ item }">
                  <v-chip x-small :color="item.ceubArchivoId ? 'teal darken-2' : 'grey lighten-1'" :dark="!!item.ceubArchivoId">
                    {{ item.ceubArchivoId ? 'si' : 'no' }}
                  </v-chip>
                </template>
                <template v-slot:item.programas="{ item }">
                  <v-chip x-small color="teal lighten-5" class="teal--text text--darken-3" @click="$refs.refmodalVerProgs_esam.openmodal(item)">
                    {{ item.programas ? item.programas.length : 0 }}
                  </v-chip>
                </template>
                <template v-slot:item.estado="{ item }">
                  <v-chip x-small :color="item.estado === 'inscrito' ? 'green' : 'orange'" dark>
                    {{ item.estado }}
                  </v-chip>
                </template>
                <template v-slot:[`item.opt`]="{ item }">
                  <v-btn color="teal darken-2" class="white--text" :loading="item.xloading" @click="crear_programa(item)">
                    <v-icon left small>mdi-plus-circle</v-icon>
                    Crear programa Esam
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cerrar()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <modalVerProgs_esam ref="refmodalVerProgs_esam" />
  </div>
</template>

<script> 
import gql from 'graphql-tag';
import {meses,headers_punis3} from './utils';
import ProgramaUniversidadService from '../../pagos/services/programa-universidad.service';
import modalVerProgs_esam from './modal-ver-progs_esam.vue';
import { query } from '../autoria/posgraditos/utils.js';

  export default {
    components:{modalVerProgs_esam},
    data() {
      return {
        loading: true, 
        loading_aprob: false, 
        dialog: false,    
        xheaders_punis: [],
        xmeses: [],
        escogidos: [],
        filteredEscogidos: [],
        input:{
            nombre_oferta:'',
            mes: new Date().getMonth(),
            anio: new Date().getFullYear(),
        }
      };
    }, 
    watch:{
      'input.mes': function() {
        this.listar()
      },
      'input.anio': function() {
        this.listar()
      }
    },
    methods: {
      async openmodal() {  
        this.loading = false;
        this.dialog = true; 
        this.input.nombre_oferta = '';
        this.input.mes = new Date().getMonth();
        this.input.anio = new Date().getFullYear();
        this.xmeses = meses();
        this.xheaders_punis = headers_punis3();
        this.escogidos = []

        this.listar()
      }, 
      cerrar() {
        this.dialog = false;
      }, 
      mesTexto(mesId) {
        const m = this.xmeses.find(x => x.id === mesId);
        return m ? m.text : mesId;
      },
      
      async listar() {
        this.loading = true;
        const q = {
          mes: this.input.mes,
          anio: this.input.anio,
        }
        
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const graphql = JSON.stringify({
          query: "query escogidos($q:QueryEscogidos!){ escogidos(q:$q){id seleccionados_por nombre_oferta mes anio seleccionados aprobados fecha_registro} }",
          variables: {q:q}
        })
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: graphql, 
        };

        const res = await fetch(process.env.VUE_APP_PROYECTOS_API, requestOptions).then(r=>r.json()).then(({data})=>data).catch(e=>e)
        this.loading = false;
        // window.console.log('res',res);
        const sedeid = this.$store.state.CARGO.sede.id;
        if(res && res.escogidos){
            res.escogidos.map(e=>{
                e.seleccionados = JSON.parse(e.seleccionados);
                e.aprobados = JSON.parse(e.aprobados);
                if(!e.aprobados) e.aprobados = []
                e.aprobados = e.aprobados.filter(a=>a.sede.id==sedeid);
                e.aprobados.map(a=>{
                    a.xloading = false;
                    return a;
                })
                e.xaprobar = []
                return e;
            })
            this.escogidos = res.escogidos;
            this.filteredEscogidos = res.escogidos.filter(x=>x.aprobados.length > 0)
        }
      },

      async crear_programa(row){    
        window.localStorage.removeItem('rest_idprograma');
        row.xloading = true; 
        const resprog = await ProgramaUniversidadService.findOne(row.id); // row.id -> en teoria id es el programa_universidad_id
        // window.console.log('resprog', row,resprog);
        const programa_univ = resprog.data.datos
        window.console.log('programa_univ', programa_univ);
        
        const grupos = programa_univ.programas.length + 1;
        const version = programa_univ.version;
        const modulos = programa_univ.modulosProgramasUniversidades
        const precios = programa_univ.listasPreciosPorTipo
        const name = programa_univ.programaNombre
        if( !modulos || modulos.length==0 ){
          this.$root.$notify.show('Faltan los modulos en el programa universidad '+name, {color:'red',x: 'right',timeout:3800});
          row.xloading = false;
          return
        } 
        if( !precios || precios.length==0 ){
          this.$root.$notify.show('Falta la lista de precios en programa universidad '+name, {color:'#AA0000',x: 'right',timeout:3800});
          row.xloading = false;
          return
        } 
        
        const s = query(1,row.programaNombre)
        let sql = gql`${s}`;
        const r = await this.$apollo.query({ query: sql }).then(({ data: { getPostgrados } }) => getPostgrados);
        window.console.log('r >>>> ', r);
        let postgrado_id = 0
        if(r && r.length>0) {
          postgrado_id = r[0].id;
        }else{
          const data = {};
          data.idarea = 1;
          data.idcategoria = 1;
          data.nombre = row.programaNombre;
          data.portada = 'portadita.jpg';
          data.creditaje = 1;
          data.duracion = 1;
          data.unidad_duracion = 1;
          data.carga_horaria = 1;
          data.unidad_negocio_id = this.$store.state.CARGO.sede.unidad_negocio;

          let sql = gql`mutation{ createPostgrado(input:${window.stringifyObject(data)}){ok,postgrado{id,nombre,unidad_duracion},errors{message}} }`;
          let res = await this.$apollo.mutate({  mutation: sql }).then(({ data }) => data).catch(e=>e);
          if(res && res.createPostgrado && res.createPostgrado.ok){
            postgrado_id = res.createPostgrado.postgrado.id;
          }
        }
        
        let sql2 = gql`query{ getPostgrado(id:${postgrado_id}){id,nombre,duracion,creditaje,unidad_negocio_id,status,carga_horaria,unidad_duracion,estado,portada,objetivo,dirigido,categoria{id nombre clase_netsuite_id}, area{id nombre}, clasenetsuite{id, nombre} } }`;
        let resp = await this.$apollo.query({query: sql2}).then(({data}) =>data).catch(e=>e);
        row.xloading = false;

        if(!resp || !resp.getPostgrado) {
            this.$root.$notify.show('No se encontró el Postgrado vinculado ID:'+postgrado_id, {color:'red',x: 'right',timeout:1800});
            return;
        }

        const fechaic = row.fecha_inicio_campana
        window.sessionStorage.setItem('xpostgradorest', JSON.stringify(resp.getPostgrado));
        this.$router.push(`programa_reg_from_oferta?programa_universidad_id=${row.id}&modalidad=${programa_univ.modalidad}&fechaic=${fechaic}&grupo=${grupos}&version=${version}`);
        
      }
    },
  };
</script>

<style scoped>
.va-card {
  border-radius: 14px;
  overflow: hidden;
}
.va-hero {
  background: linear-gradient(120deg, #004D40 0%, #00796B 45%, #4DB6AC 100%);
}
</style>
